<template>
  <footer class="site-footer">
    <div class="container">
      <div class="footer-top">
        <div class="footer-brand">
          <router-link to="/" class="brand"><img class="brand-logo brand-logo-white" src="/marketing-assets/images/logo/ucari-logo-white-v3.png" alt="UCARI" /></router-link>
          <p>UCARI equips retailers with lab-backed pet and human intolerance testing kits, and an ingredient checker that keeps customers coming back.</p>
        </div>
        <div v-for="column in columns" :key="column.title" class="footer-col">
          <h4>{{ column.title }}</h4>
          <ul><li v-for="link in column.links" :key="link.to"><router-link :to="link.to">{{ link.label }}</router-link></li></ul>
        </div>
      </div>
      <div class="footer-bottom">
        <span>&copy; {{ currentYear }} UCARI, Inc. All rights reserved.</span>
        <div class="legal-links">
          <router-link to="/privacy">Privacy Policy</router-link>
          <router-link to="/terms">Terms of Service</router-link>
          <router-link to="/sitemap">Sitemap</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'MarketingFooter',
  data() {
    return {
      columns: [
        { title: 'Products', links: [
          { label: 'Human Intolerance Kit', to: '/human-kit' },
          { label: 'Pet Intolerance Kit', to: '/pet-kit' },
          { label: 'Ingredient Checker', to: '/ingredient-checker' },
        ] },
        { title: 'For Retailers', links: [
          { label: 'Why UCARI', to: '/why-retailers' },
          { label: 'Retailer Program', to: '/retailer-program' },
          { label: 'Wholesale Pricing', to: '/pricing' },
          { label: 'Revenue Calculator', to: '/revenue-calculator#calculator' },
          { label: 'Become a Retailer', to: '/register' },
        ] },
        { title: 'Company', links: [
          { label: 'About', to: '/about' },
          { label: 'Scientific Information', to: '/science' },
          { label: 'FAQ', to: '/faq' },
          { label: 'Contact', to: '/contact' },
        ] },
      ],
    };
  },
  computed: {
    currentYear() { return new Date().getFullYear(); },
  },
};
</script>
